import React, { useEffect, useState, useRef } from "react";
import "../highlightCourses.css";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Button, Col, Container, Row } from "react-bootstrap";
import ContactModal from "./ContactModal";
import ScrollToCourses from "./scrollToCourses";
import { useConsent } from "../context/ConsentContext";
import Loading from "./Loading";

const API = "https://backend.seinimlicht.de/wp-json/wp/v2/";

const HighlightCourses = () => {
  const carouselRef = useRef(null);
  const [highlights, setHighlights] = useState([]);
  const [loading, setLoading] = useState(true);
  const { cookieSettings, updateCookieSettings } = useConsent();
  const [showMoreVideos, setShowMoreVideos] = useState(false);

  useEffect(() => {
    async function fetchHighlights() {
      try {
        setLoading(true);
        const res = await fetch(
          `${API}posts?categories=20&per_page=10&orderby=date&order=desc&_embed=1`
        );
        if (!res.ok) return;
        const data = await res.json();
        setHighlights(data);
      } catch (err) {
        console.error("Fehler beim Laden der Highlight-Kurse:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchHighlights();
  }, []);

  const options = {
    loop: true,
    center: true,
    autoplay: false,
    dots: true,
    nav: true,
    navText: [
      '<span class="arrowCoursesCarousel prevCoursesCarousel fas fa-chevron-left"></span>',
      '<span class="arrowCoursesCarousel nextCoursesCarousel fas fa-chevron-right"></span>',
    ],
    lazyLoad: true,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1200: { items: 2 },
    },
  };

  const transformH4Tags = (html) => {
    if (!html) return "";
    return html.replace(
      /<h4(?![^>]*\bitem-content-headline\b)([^>]*)>/gi,
      '<h4 class="item-content-headline"$1>'
    );
  };

  const cleanUpPdfLinks = (html) => {
    if (!html) return "";
    return html
      .replace(/<div>\s*<a[^>]*href="[^"]+\.pdf"[^>]*>.*?<\/a>\s*<\/div>/i, "")
      .replace(/<p>\s*<a[^>]*href="[^"]+\.pdf"[^>]*>.*?<\/a>\s*<\/p>/i, "")
      .replace(/<a[^>]*href="[^"]+\.pdf"[^>]*>.*?<\/a>/i, "");
  };

  const extractPdfUrl = (html, embedded) => {
    if (!html && !embedded) return null;
    const match = html?.match(/href="([^"]+\.pdf)"/i);
    if (match?.[1]) return match[1];

    const attachments = embedded?.["wp:attachment"];
    if (attachments?.length) {
      const pdf = attachments.find(
        (file) =>
          file.mime_type === "application/pdf" ||
          /\.pdf(\?.*)?$/i.test(file.source_url)
      );
      if (pdf) return pdf.source_url;
    }
    return null;
  };

  return (
    <section id="testimonial">
      <Container>
        <div className="row">
          <Col md={12} style={{ marginBottom: "24px" }}>
            <h2 className="display-6">Ausbildung & Begleitung</h2>
            <hr />
          </Col>

          <Col md={12} style={{ marginTop: "12px" }}>
            {loading ? (
              <Loading />
            ) : highlights.length > 0 ? (
              <OwlCarousel
                id="highlight-courses"
                ref={carouselRef}
                {...options}
              >
                {highlights.map((item) => {
                  const image =
                    item?.yoast_head_json?.og_image?.[0]?.url ||
                    item?.featured_image_url;
                  const pdfUrl = extractPdfUrl(
                    item?.content?.rendered,
                    item?._embedded
                  );

                  return (
                    <div className="item" key={item.id}>
                      <div className="shadow-effect-courses-carousel">
                        {image && (
                          <img
                            className="img-course"
                            src={image}
                            alt={item.title?.rendered || "Highlight"}
                          />
                        )}

                        <div className="item-content">
                          <div className="course-name">
                            <h4
                              style={{
                                marginBottom: 0,
                                marginTop: "14px",
                              }}
                              dangerouslySetInnerHTML={{
                                __html: item?.title?.rendered || "",
                              }}
                            />
                          </div>

                          <div
                            dangerouslySetInnerHTML={{
                              __html: transformH4Tags(
                                cleanUpPdfLinks(item?.content?.rendered)
                              ),
                            }}
                          />

                          {pdfUrl && (
                            <Button
                              className="caption-buttons"
                              href={pdfUrl}
                              download
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                marginTop: "2px",
                                marginBottom: "4px",
                              }}
                            >
                              Download Info PDF
                            </Button>
                          )}

                          <ContactModal
                            subject={item?.title?.rendered || "Anfrage"}
                            classes="btn-secondary caption-buttons"
                            btntitle="Jetzt anmelden*"
                          />
                          <p>*Erstgespräch (1/2 Std. gratis)</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </OwlCarousel>
            ) : (
              <p>Keine Highlight-Kurse gefunden.</p>
            )}

            <div
              style={{
                textAlign: "center",
                marginTop: "30px",
                marginBottom: "40px",
              }}
            >
              <ScrollToCourses targetId="eventsSection" buttonText="" />
            </div>
          </Col>
        </div>

        {/* VIDEOS */}
        <Col md={12} style={{ marginBottom: "24px" }}>
          <h3 className="display-7">
            Im Gespräch mit den Hüter:innen des Wassers
          </h3>

          <Row>
            <Col md={12}>
              <h3>Zur Ausbildung 2026</h3>
            </Col>

            {["PGZtfWNi0oQ", "lzVnJaH80cU?si=Q7CF0NNOBVVXajsJ"].map(
              (id, index) => (
                <Col
                  sm={12}
                  lg={4}
                  key={`ausbildung-${index}`}
                  style={{ paddingBottom: "16px" }}
                >
                  <div className="video-responsive">
                    <iframe
                      src={`https://www.youtube.com/embed/${id}`}
                      title={`Ausbildung 2026 Video ${index + 1}`}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    ></iframe>
                  </div>
                </Col>
              )
            )}
          </Row>

          {/* INTERVIEWS */}
          <Row>
            {cookieSettings.preferences ? (
              <>
                <Col md={12}>
                  <h3>Interviews</h3>
                </Col>

                {/* 3 Grundvideos */}
                {[
                  "NSTIlIPepHY?si=JsuOxThg9sIhNzwi",
                  "_Z1Vqy1GJDY?si=OzjpfqFcWDo6ggZf",
                  "zq_mxBj3hnw?si=TWbl176GPoM8erBG",
                ].map((id, index) => (
                  <Col
                    sm={12}
                    lg={4}
                    key={index}
                    style={{ paddingBottom: "16px" }}
                  >
                    <div className="video-responsive">
                      <iframe
                        src={`https://www.youtube.com/embed/${id}`}
                        title={`Ausbildung Interview ${index + 1}`}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </Col>
                ))}

                {/* Erweiterbare Videos */}
                {showMoreVideos && (
                  <>
                    {[
                      "wjWc8DrVRE8?si=HeOJ4TRB8JvzOzRT",
                      "DI9v4o6xHhg?si=8yfJAJhAgnqGGvVF",
                      "ylL8hJyusxE?si=7Nuw13U3ydxTIzfP",
                    ].map((id, index) => (
                      <Col
                        sm={12}
                        lg={4}
                        key={`extra-${index}`}
                        style={{ paddingBottom: "16px" }}
                      >
                        <div className="video-responsive">
                          <iframe
                            src={`https://www.youtube.com/embed/${id}`}
                            title={`Zusatz-Interview ${index + 1}`}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </Col>
                    ))}
                  </>
                )}

                <Col md={12} style={{ marginTop: "20px" }}>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      onClick={() => setShowMoreVideos(!showMoreVideos)}
                      className="btn btn-secondary px-4 py-2 text-nowrap"
                    >
                      {showMoreVideos
                        ? "Weniger Interviews"
                        : "Weitere Interviews"}
                    </Button>
                  </div>
                </Col>
              </>
            ) : (
              <>
                <Col
                  sm={12}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 20,
                  }}
                >
                  <h3 style={{ fontWeight: 400, textAlign: "center" }}>
                    Bitte akzeptiere die Drittanbieter-Cookies, um dir diesen
                    Inhalt ansehen zu können.
                  </h3>
                  <Button
                    onClick={() =>
                      updateCookieSettings({
                        necessary: true,
                        preferences: true,
                        statistics: false,
                        marketing: false,
                      })
                    }
                  >
                    Akzeptieren
                  </Button>
                </Col>
              </>
            )}
          </Row>
        </Col>
      </Container>
    </section>
  );
};

export default HighlightCourses;
